import validate from "C:/BuildAgent/work/546b3c95a3861166/b2c/b2c-nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45route_45global from "C:/BuildAgent/work/546b3c95a3861166/b2c/b2c-nuxt/middleware/01.route.global.ts";
import _02_45auth_45global from "C:/BuildAgent/work/546b3c95a3861166/b2c/b2c-nuxt/middleware/02.auth.global.ts";
import _03_45cart_45global from "C:/BuildAgent/work/546b3c95a3861166/b2c/b2c-nuxt/middleware/03.cart.global.ts";
import _04_45analytics_45global from "C:/BuildAgent/work/546b3c95a3861166/b2c/b2c-nuxt/middleware/04.analytics.global.ts";
import _05_45affiliate_45global from "C:/BuildAgent/work/546b3c95a3861166/b2c/b2c-nuxt/middleware/05.affiliate.global.ts";
import manifest_45route_45rule from "C:/BuildAgent/work/546b3c95a3861166/b2c/b2c-nuxt/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45route_45global,
  _02_45auth_45global,
  _03_45cart_45global,
  _04_45analytics_45global,
  _05_45affiliate_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}